export default {
      id: "i-arrow-right5-usage",
      viewBox: "0 0 10 7",
      url: __webpack_public_path__ + "img/sprite.svg#i-arrow-right5",
      toString: function () {
        return this.url;
      }
    }